/**
 * Politica de senha do sistema, espelhando a regra do servidor
 * (Password::defaults em AppServiceProvider).
 *
 * Existe para a tela poder mostrar o que falta enquanto a pessoa digita, em vez
 * de recusar so depois de enviar. O servidor continua sendo a autoridade: isto
 * aqui e conveniencia, nao validacao.
 */

export interface RegraDeSenha {
  chave: string;
  texto: string;
  atende: (senha: string) => boolean;
}

export const REGRAS_DE_SENHA: RegraDeSenha[] = [
  { chave: 'tamanho', texto: 'Pelo menos 8 caracteres', atende: (s) => s.length >= 8 },
  { chave: 'maiuscula', texto: 'Uma letra maiúscula', atende: (s) => /[A-ZÀ-Þ]/.test(s) },
  { chave: 'minuscula', texto: 'Uma letra minúscula', atende: (s) => /[a-zà-þ]/.test(s) },
  { chave: 'numero', texto: 'Um número', atende: (s) => /\d/.test(s) },
  { chave: 'simbolo', texto: 'Um símbolo, como @ # ! $ %', atende: (s) => /[^\p{L}\p{N}]/u.test(s) },
];

export const senhaAtendeAPolitica = (senha: string): boolean =>
  REGRAS_DE_SENHA.every((r) => r.atende(senha));
